import axios from "axios";
import { IGetQuotationRequest } from "../models/request/IGetQuotationRequest";

export const getFormApi = async () => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/userForm.php`,
    {
      action: "getForm",
    }
  );
  return response.data;
};

export const getQuoteApi = async (queryParams: IGetQuotationRequest) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/userForm.php`,
    {
      action: "getQuotation",
      ...queryParams,
    }
  );
  return response.data;
};

export const formPostApi = async (formData: FormData) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/formPost.php`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
